module.exports = __webpack_public_path__ + "img/sprout-outline.7a271632.svg";